"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import React, { useContext, useEffect, useState } from "react";
import EventReadDetail from "@/app/(main)/(club)/mes-clubs/[id]/components/event-read-detail";
import { getClubEvent, updateEventClubTransition } from "@/app/api/dynabuy-back/api-events";
import Button from "@/components/button";
import ClientFlash from "@/components/global/client-flash";
import ComponentLoading from "@/components/global/component-loading";
import MainTitle from "@/components/global/main-title";
import { flashContext } from "@/context/flash-context";
import { sidebarContext } from "@/context/sidebar-context";
import { useModalStore } from "@/stores/modal-store";
import { EventTransitionEnum } from "@/TS/Enums/global_enums";
import { EventRead } from "@/TS/Interfaces/global_interfaces";
interface CancelEventProps {
  event: EventRead;
  isModal?: boolean;
}
const CancelEvent: React.FC<CancelEventProps> = t0 => {
  const $ = _c(40);
  const {
    event,
    isModal: t1
  } = t0;
  const isModal = t1 === undefined ? false : t1;
  const [fetchedEvent, setFetchedEvent] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [disableButtons, setDisableButtons] = useState(false);
  const {
    close
  } = useModalStore();
  const {
    setVal
  } = useContext(sidebarContext);
  const {
    applyFlashContext
  } = useContext(flashContext);
  const router = useRouter();
  let t2;
  if ($[0] !== event.clubSlug || $[1] !== event.startDate || $[2] !== event.type || $[3] !== fetchedEvent) {
    t2 = () => {
      if (fetchedEvent) {
        return;
      }
      const handleFetch = async () => {
        setIsLoading(true);
        setFetchedEvent(await getClubEvent(event.type, event.clubSlug, event.startDate.split("T")[0]));
        setIsLoading(false);
      };
      handleFetch();
    };
    $[0] = event.clubSlug;
    $[1] = event.startDate;
    $[2] = event.type;
    $[3] = fetchedEvent;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== event || $[6] !== fetchedEvent) {
    t3 = [event, fetchedEvent];
    $[5] = event;
    $[6] = fetchedEvent;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== close || $[9] !== isModal || $[10] !== setVal) {
    t4 = () => {
      if (isModal) {
        close();
      } else {
        setVal("");
      }
    };
    $[8] = close;
    $[9] = isModal;
    $[10] = setVal;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleClose = t4;
  let t5;
  if ($[12] !== applyFlashContext || $[13] !== event.clubSlug || $[14] !== event.startDate || $[15] !== event.type || $[16] !== handleClose || $[17] !== router) {
    t5 = async () => {
      setDisableButtons(true);
      const res = await updateEventClubTransition(EventTransitionEnum.CANCEL, event.type, event.clubSlug, event.startDate.split("T")[0]);
      if (!res.error) {
        setDisableButtons(false);
        handleClose();
        applyFlashContext({
          message: "La r\xE9union a \xE9t\xE9 annul\xE9e avec succ\xE8s !",
          type: "success2"
        }, 18000000);
        router.refresh();
      } else {
        setDisableButtons(false);
        applyFlashContext({
          message: res.message ?? "",
          type: "primary",
          position: "event-cancel"
        }, 5000);
      }
    };
    $[12] = applyFlashContext;
    $[13] = event.clubSlug;
    $[14] = event.startDate;
    $[15] = event.type;
    $[16] = handleClose;
    $[17] = router;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const handleCancelEvent = t5;
  if (!fetchedEvent) {
    let t6;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <ComponentLoading />;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    return t6;
  }
  let t6;
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MainTitle className="text-center w-full" title={"Annuler ma r\xE9union"} />;
    t7 = <p className="text-sm italic mb-8 text-center">Vous êtes sur le point d'annuler cette réunion, êtes-vous sûr ?</p>;
    $[20] = t6;
    $[21] = t7;
  } else {
    t6 = $[20];
    t7 = $[21];
  }
  let t8;
  if ($[22] !== fetchedEvent || $[23] !== isLoading) {
    t8 = <EventReadDetail event={fetchedEvent} isLoading={isLoading} />;
    $[22] = fetchedEvent;
    $[23] = isLoading;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ClientFlash path="event-cancel" />;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== disableButtons || $[27] !== handleClose) {
    t10 = <Button onClick={handleClose} className="w-full" variant="unfilled" colorTheme="secondary" disabled={disableButtons}>Retour</Button>;
    $[26] = disableButtons;
    $[27] = handleClose;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== handleCancelEvent) {
    t11 = () => {
      handleCancelEvent();
    };
    $[29] = handleCancelEvent;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== disableButtons || $[32] !== t11) {
    t12 = <Button onClick={t11} className="w-full" variant="filled" disabled={disableButtons}>Confirmer</Button>;
    $[31] = disableButtons;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t12) {
    t13 = <div className="flex gap-4 mt-11 px-4">{t10}{t12}</div>;
    $[34] = t10;
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t13 || $[38] !== t8) {
    t14 = <div className="flex md:w-3/5 w-full mx-auto flex-col">{t6}{t7}{t8}{t9}{t13}</div>;
    $[37] = t13;
    $[38] = t8;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
};
export default CancelEvent;